import { graphql } from "react-relay";
import { EventSuggestedTimesWarning } from "./EventSuggestedTimesWarning";

export const rendererQuery = graphql`
  query EventSuggestedTimesWarningRendererQuery($orgRelayId: ID!) {
    node(id: $orgRelayId) {
      ...EventSuggestedTimesWarning_org
    }
  }
`;
